import { Clear, Delete } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "src/components/common/DataTables/DataTable";
import SelectDeliveryCompany from "./SelectDeliveryCompany";
import ShipmentBoxesListDialog from "./ShipmentBoxesListDialog";
import {
  useAssignDeliveryComapnyMutation,
  useGetWalletBalanceQuery,
  useReturnMapitShipOrderMutation,
  useReturnMapitShipOrderSAdminMutation,
} from "src/_api/mapitShipApi";
import { ChargeBalanceDialog } from "src/_modules/MapitShip/components";
import { IssuesListDialog } from "src/_modules/common";
import { ROLES } from "src/constants";
import { useSelector } from "react-redux";
import ConfirmPasswordDialogAdmin from "src/_modules/common/Dialogs/ConfirmPasswordDialogAdmin";

const $COLUMN_WIDTH = 200;
export default function ConfirmOrdersForShipmentDialog({
  open,
  onClose,
  selectedOrders,
  shipmentType = "DROP_OFF",
}) {
  const { t } = useTranslation();
  const fullScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const { profile } = useSelector((state) => state.entities.profile);

  const [orders, setOrders] = useState([]);
  console.log(orders);

  useEffect(() => {
    // Add safety check and ensure selectedOrders exists
    if (selectedOrders?.length) {
      setOrders(
        selectedOrders.map((order) => ({ ...order, deliveryOption: null })),
      );
    } else {
      // Reset to empty array if selectedOrders is empty/undefined
      setOrders([]);
    }
  }, [selectedOrders]);
  //======= Wallet and Balance ======
  const totalShipmentsPrice = useMemo(() => {
    return orders.reduce(
      (acc, order) => acc + (order?.deliveryOption?.price ?? 0),
      0,
    );
  }, [orders]);

  const [openBalanceDialog, setOpenBalanceDialog] = useState(false);
  const { data: wallet } = useGetWalletBalanceQuery({});

  //======= Issues ======
  const [openIssuesDialog, setOpenIssuesDialog] = useState(false);
  const [issues, setIssues] = useState([]);

  const closeIssuesDialogHandler = () => {
    setOpenIssuesDialog(false);
    setIssues([]);
  };

  //======= Assign Delivery Company For Creating Drop off shipment =========
  const [
    assignDeliveryComapny,
    {
      isLoading: assignDeliveryComapnyLoading,
      isSuccess: assignDeliveryComapnyIsSuccess,
      error: assignDeliveryComapnyError,
      reset: assignDeliveryComapnyReset,
    },
  ] = useAssignDeliveryComapnyMutation();

  const [validationError, setValidationError] = useState(null);

  const createDropOffShipment = async () => {
    try {
      let error = null;
      setValidationError(null);
      let payload = [];

      orders.forEach((order) => {
        if (!order?.deliveryOption) {
          error = t("Please select delivery company for all orders");
          return;
        }
        payload.push({
          orderId: order.id,
          deliveryOption: order.deliveryOption,
        });
      });

      if (!!error) {
        setValidationError(error);
        return;
      }

      if (wallet?.balance >= totalShipmentsPrice) {
        let response = await assignDeliveryComapny({
          orders: payload,
        }).unwrap();
        if (!!response?.shipmentsErrors?.length) {
          setIssues(response.shipmentsErrors);
          setOpenIssuesDialog(true);
        } else {
          setTimeout(() => {
            onClose(true);
          }, 2000);
        }
      } else {
        setOpenBalanceDialog(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  //======== Return Order =======

  const [
    returnMapitShipOrder,
    {
      isLoading: returnMapitShipOrderLoading,
      error: returnMapitShipOrderError,
      isSuccess: returnMapitShipOrderIsSuccess,
      reset: returnMapitShipOrderOrderReset,
    },
  ] = useReturnMapitShipOrderMutation();

  const [
    returnMapitShipOrderSAdmin,
    {
      isLoading: returnMapitShipAdminLoading,
      error: returnMapitShipOrderAdminError,
      isSuccess: returnMapitShipOrderAdminIsSuccess,
      // reset: returnMapitShipOrderOrderAdminReset,
    },
  ] = useReturnMapitShipOrderSAdminMutation();

  const createReturnShipment = async (adminPassword) => {
    try {
      setValidationError(null);

      if (!orders[0]?.deliveryOption) {
        setValidationError(t("Please select delivery company for all orders"));
        return;
      }

      let payload = {
        orderId: orders[0]?.id,
        deliveryOption: orders[0]?.deliveryOption,
        ...(profile?.role === ROLES.admin && { password: adminPassword }),
      };

      if (profile?.role === ROLES.admin) {
        await returnMapitShipOrderSAdmin(payload).unwrap();
        setTimeout(() => onClose(), 700);
      } else {
        if (wallet?.balance >= totalShipmentsPrice) {
          await returnMapitShipOrder(payload).unwrap();
          setTimeout(() => onClose(), 700);
        } else {
          setOpenBalanceDialog(true);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = () => {
    try {
      if (shipmentType === "DROP_OFF") {
        createDropOffShipment();
      } else if (shipmentType === "RETURN") {
        createReturnShipment(adminPassword);
      }
    } catch (error) {
      console.error(error);
    }
  };

  //======= Remove Order =========

  const removeOrder = (id) => {
    setOrders(orders.filter((order) => order.id !== id));
  };

  //======= Table Columns =========
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [boxes, setBoxes] = useState([]);
  const [openEditBoxesDialog, setOpenEditBoxesDialog] = useState(false);

  const openEditBoxesDialogHandler = ({ orderId, boxes }) => {
    setBoxes(boxes);
    setSelectedOrderId(orderId);
    setOpenEditBoxesDialog(true);
  };

  const closeEditBoxesDialogHandler = () => {
    setOpenEditBoxesDialog(false);
    setBoxes([]);
    setSelectedOrderId(null);
  };

  const PackageCount = ({ value, row }) => {
    return (
      <Box
        display="flex"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography sx={{ mr: 1 }}>{value}</Typography>
        {shipmentType !== "RETURN" && (
          <Button
            onClick={(event) => {
              event.stopPropagation();
              openEditBoxesDialogHandler({
                orderId: row?.id,
                boxes: row?.boxes,
              });
            }}
            size="small"
            variant="contained"
            color="primary"
          >
            {t("Edit")}
          </Button>
        )}
      </Box>
    );
  };

  const selectDeliveryCompanyHandler = ({ orderId, deliveryCompany }) => {
    setOrders(
      orders.map((order) =>
        order.id === orderId
          ? { ...order, deliveryOption: deliveryCompany }
          : order,
      ),
    );
  };

  let columns = [
    {
      field: "orderNumber",
      sortable: false,
      headerName: t("Order No."),
      width: $COLUMN_WIDTH * 0.75,
    },
    {
      field: "user",
      sortable: false,
      valueGetter: ({ value }) => value?.address?.city,
      headerName: t("Destination"),
      width: $COLUMN_WIDTH * 1,
    },
    {
      field: "deliveryOption",
      sortable: false,
      headerName: t("Select delivery company"),
      renderCell: ({ value, row }) => (
        <SelectDeliveryCompany
          orderId={row?.id}
          value={value}
          onChange={selectDeliveryCompanyHandler}
        />
      ),
      width: $COLUMN_WIDTH * 1.8,
    },
    {
      field: "packagesCount",
      sortable: false,
      headerName: t("Boxes Count"),
      renderCell: PackageCount,
      width: $COLUMN_WIDTH * 0.75,
    },
    {
      field: "actualweight",
      valueGetter: ({ row }) =>
        row?.otoIntegration?.calculatedWeight > 0
          ? row.otoIntegration.calculatedWeight
          : row?.otoIntegration?.actualWeight,
      sortable: false,
      headerName: t("Actual weight"),
      width: $COLUMN_WIDTH * 0.5,
      align: "center",
    },
    {
      field: "volumetricweight",
      valueGetter: ({ row }) => row?.otoIntegration?.volumetricWeight,
      sortable: false,
      headerName: t("Volumetric weight"),
      width: $COLUMN_WIDTH * 0.5,
      align: "center",
    },
    {
      field: "price",
      sortable: false,
      valueGetter: ({ row }) => row?.deliveryOption?.price ?? "",
      headerName: t("Price"),
      width: $COLUMN_WIDTH * 0.5,
      align: "center",
    },
    {
      field: "Delete",
      headerName: t("Delete"),
      sortable: false,
      renderCell: ({ row }) => (
        <IconButton
          color="error"
          disabled={orders?.length <= 1}
          onClick={(event) => {
            event.stopPropagation();
            removeOrder(row.id);
          }}
        >
          <Delete />
        </IconButton>
      ),
      width: $COLUMN_WIDTH * 0.4,
      align: "center",
    },
  ];

  useEffect(() => {
    if (!open) {
      setOrders([]);
      setValidationError(null);
      returnMapitShipOrderOrderReset();
      assignDeliveryComapnyReset();
    }
  }, [open]);

  const isLoading =
    assignDeliveryComapnyLoading ||
    returnMapitShipOrderLoading ||
    returnMapitShipAdminLoading;
  const isSuccess =
    assignDeliveryComapnyIsSuccess ||
    returnMapitShipOrderIsSuccess ||
    returnMapitShipOrderAdminIsSuccess;
  const error =
    assignDeliveryComapnyError ||
    returnMapitShipOrderError ||
    returnMapitShipOrderAdminError;
  const [openAdminDialog, setOpenAdminDialog] = useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  return (
    <>
      <ChargeBalanceDialog
        open={openBalanceDialog}
        onClose={() => setOpenBalanceDialog(false)}
      />
      <ShipmentBoxesListDialog
        open={openEditBoxesDialog}
        onClose={closeEditBoxesDialogHandler}
        orderId={selectedOrderId}
        boxesData={boxes}
      />
      <IssuesListDialog
        open={openIssuesDialog}
        description={
          <Typography
            variant="subtitle1"
            sx={{ color: "text.lighter", letterSpacing: "normal" }}
          >
            <span style={{ color: "red" }}>
              {issues.length > 1
                ? t(`IssuesCount`, { count: issues.length })
                : t("Issue")}
            </span>
            {t("createOrdresShipmentErrorMsg")}
          </Typography>
        }
        issues={issues}
        errorLable={"The order number"}
        onClose={closeIssuesDialogHandler}
      />
      <Dialog
        open={open}
        fullWidth
        maxWidth="lg"
        fullScreen={fullScreen}
        onClose={(e) => e.preventDefault()}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
          {shipmentType === "RETURN"
            ? t("Create Return Shipment")
            : t("Create Shipment")}
          <IconButton sx={{ ml: "auto" }} onClick={onClose} color="primary">
            <Clear />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box display="flex" alignItems="center" mb={1}>
            {profile?.merchant?.role === ROLES.merchant ? (
              <>
                <Typography variant="h6" sx={{ mr: 3 }}>
                  {t("Available Credits") + " : "}
                </Typography>

                <Typography>
                  {!!wallet?.balance
                    ? `${wallet?.balance?.toFixed(2)} ${t("Currency")}`
                    : "-"}
                </Typography>
              </>
            ) : (
              ""
            )}
          </Box>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography variant="h6" sx={{ mr: 3 }}>
              {t("Total Shipping Cost") + " : "}
            </Typography>
            <Typography>
              {!!totalShipmentsPrice
                ? `${totalShipmentsPrice?.toFixed(2)} ${t("Currency")}`
                : "-"}
            </Typography>
          </Box>
          <Box height="61vh">
            {orders && orders?.length > 0 ? (
              <>
                <DataTable
                  tableId="DATA-TABLE-DIALOG-ID"
                  page={1}
                  rows={orders}
                  columns={columns}
                  pageSize={20}
                  hideFooterPagination={true}
                  checkboxSelection={false}
                />
              </>
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Typography>{t("No orders selected")}</Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          {!!validationError && (
            <Typography color="error">{t(validationError)}</Typography>
          )}
          {!!error && <Typography color="error">{error}</Typography>}
          {isSuccess && (
            <Typography color="success.main">
              {t("Done successfully")}
            </Typography>
          )}
          <Box mr="auto" />
          <LoadingButton
            type="button"
            loading={isLoading}
            onClick={onClose}
            color="primary"
            variant="contained"
            sx={{ textTransform: "none" }}
          >
            {t("Cancel")}
          </LoadingButton>
          <LoadingButton
            type="button"
            loading={isLoading}
            onClick={() => {
              if (profile.role === ROLES.admin) {
                setOpenAdminDialog(true);
              } else {
                onSubmit();
              }
            }}
            color="primary"
            variant="contained"
            sx={{ textTransform: "none" }}
          >
            {t("Confirm")}
          </LoadingButton>
          <ConfirmPasswordDialogAdmin
            open={openAdminDialog}
            title={
              "Please enter your password to be able to create a return shipment"
            }
            password={adminPassword}
            loading={isLoading}
            onPasswordChange={setAdminPassword}
            onClose={() => {
              setOpenAdminDialog(false);
              setAdminPassword("");
            }}
            onConfirm={() => {
              onSubmit(adminPassword);
              setOpenAdminDialog(false);
            }}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
